// Filename: uiroot.js
// Timestamp: 2017.12.06-17:25:48 (last modified)
// Author(s): bumblehead <chris@bumblehead.com>

const xvnode = (ss, cfg, gr, nd, ndx) => {
  const rootisbody = nd.get('key') === '/' && cfg.isrootbody
  const rootelem = cfg.h(ndx, nd)[rootisbody ? 'body' : 'div']

  return rootisbody
    ? rootelem(ndx.childVNodesGet(ss, cfg, gr, nd))
    : rootelem('.:ui', ndx.childVNodesGet(ss, cfg, gr, nd))
}

export default {
  type: 'uiroot',
  xvnode
}
